export function assignmentFolderIdFromSearch(search: string): number | null {
  const value = Number(new URLSearchParams(search).get('folderId'));
  return Number.isInteger(value) && value > 0 ? value : null;
}

export function copyAssignmentFolderSearchParam(params: URLSearchParams, search: string): void {
  const folderId = assignmentFolderIdFromSearch(search);
  if (folderId !== null) {
    params.set('folderId', String(folderId));
  }
}

export function assignmentFolderReturnQuery(search: string): string {
  const folderId = assignmentFolderIdFromSearch(search);
  return folderId !== null ? `&assignmentFolderId=${folderId}` : '';
}

export function highlightAssignmentFromSearch(search: string): string | null {
  const value = new URLSearchParams(search).get('highlightAssignment')?.trim();
  return value || null;
}

export function highlightAssignmentReturnQuery(code?: string | null): string {
  if (!code?.trim()) return '';
  return `&highlightAssignment=${encodeURIComponent(code.trim())}`;
}

export function describeAssignmentFolderApiError(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    const record = error as { error?: unknown; message?: unknown };
    if (typeof record.message === 'string' && record.message.trim()) {
      return record.message;
    }
    switch (String(record.error ?? '')) {
      case 'folder_has_children':
        return 'Không thể xóa thư mục vì còn thư mục con bên trong. Hãy xóa hoặc di chuyển các thư mục con trước.';
      case 'folder_has_assignments':
        return 'Không thể xóa thư mục vì còn bài tập bên trong. Hãy di chuyển hoặc xóa các bài tập trước.';
      case 'cannot_trash_recycle_bin':
        return 'Không thể xóa thùng rác hệ thống.';
      case 'folder_not_empty':
        return 'Không thể xóa thư mục vì còn thư mục con hoặc bài tập bên trong.';
      default:
        break;
    }
  }
  if (error instanceof Error && error.message) return error.message;
  return 'Không thể cập nhật thư mục';
}

export function withSelectedAssignmentFolder<T extends Record<string, unknown>>(
  payload: T,
  search: string,
): T & { folderId: number | null } {
  return { ...payload, folderId: assignmentFolderIdFromSearch(search) };
}
